import changelog from "../../../../../pages/personalisation/docs/changelog-personalisation-program-administration.json5";
import * as React from 'react';
export default {
  changelog,
  React
};